import { render, staticRenderFns } from "./indexOld.vue?vue&type=template&id=4168c516&scoped=true&"
import script from "./indexOld.vue?vue&type=script&lang=js&"
export * from "./indexOld.vue?vue&type=script&lang=js&"
import style0 from "./indexOld.vue?vue&type=style&index=0&id=4168c516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4168c516",
  null
  
)

export default component.exports